export const CHILD_SAFETY_POLICY = {
  id: 'child-safety-policy',
  title: 'Child Safety Policy',
  version: 'v1.0-2026-05-17',
  effectiveDate: '17/05/2026',
  audience: 'all',
  content: `CHILD SAFETY POLICY — RESERVO

Status: DRAFT — pending solicitor review

1. PURPOSE

This policy sets out Reservo's commitment to the safety of children using the Reservo platform and the operational measures supporting that commitment.

2. SCOPE

This policy applies to all bookings, Drivers, and Reservo personnel.

3. STATEMENT OF COMMITMENT

3.1 Reservo is committed to providing a safe environment for children and to acting in accordance with:
  (a) the National Principles for Child Safe Organisations;
  (b) the Children and Young Persons (Care and Protection) Act 1998 (NSW);
  (c) the Child Protection (Working with Children) Act 2012 (NSW);
  (d) the Mandatory Reporting requirements applicable to relevant occupations.

3.2 Reservo has zero tolerance for child abuse, neglect, exploitation, or any conduct that endangers a child.

4. WHO IS A CHILD

For this policy, a child is any person under 18 years of age.

5. CHILDREN AS PASSENGERS

5.1 Children may travel on Reservo only as passengers under the booking of an adult Rider aged 18 or over.

5.2 Unaccompanied minors are not permitted.

5.3 The adult Rider is responsible for:
  (a) ensuring lawful child restraints and seating arrangements per NSW Road Rules;
  (b) accompanying the child throughout the trip;
  (c) any cancellation or no-show fees relating to the child.

6. DRIVER REQUIREMENTS

6.1 Drivers carrying children must:
  (a) hold a current Working With Children Check (WWCC) issued by the Office of the Children's Guardian, where required;
  (b) comply with NSW child restraint laws;
  (c) decline to carry a child who appears to be unaccompanied (clause 7);
  (d) report any child safety concern to Reservo immediately.

6.2 A Driver must NOT:
  (a) offer a ride to a child outside of a booking on the Reservo platform;
  (b) contact a child passenger outside the in-app messaging system;
  (c) request or accept personal contact information (phone, social media) from a child;
  (d) photograph a child without the parent's or guardian's express written consent;
  (e) engage in any conduct that could reasonably be perceived as grooming.

7. UNACCOMPANIED MINOR PROTOCOL

7.1 If a Driver arrives at a pickup and the passenger is or appears to be an unaccompanied minor:
  (a) the Driver does NOT commence the trip;
  (b) the Driver remains in a safe public location with the minor visible at all times;
  (c) the Driver contacts Reservo Operations via SOS or admin@reservo.au;
  (d) Reservo Operations contact the booking Rider and, if unreachable, NSW Police;
  (e) the Driver remains until the situation is resolved.

7.2 The Driver is paid for the standby period at a rate equivalent to waiting time on a regular trip.

8. REPORTING OBLIGATIONS

8.1 Any Driver, Rider, or Reservo personnel who has a reasonable belief that a child is at risk of significant harm must report it to:
  (a) NSW Police on 000 in immediate danger; or
  (b) the NSW Child Protection Helpline on 132 111; and
  (c) Reservo at admin@reservo.au.

8.2 Reservo Operations will:
  (a) document the report in the incident register;
  (b) preserve relevant trip records;
  (c) cooperate with police or child-welfare authorities;
  (d) notify the NSW Point to Point Transport Commissioner if the matter is a Notifiable Occurrence.

9. SCREENING AND TRAINING

9.1 Driver onboarding includes:
  (a) WWCC verification (when required);
  (b) criminal history check;
  (c) annual re-check;
  (d) mandatory child safety training module;
  (e) acknowledgement of this policy.

9.2 Reservo personnel with access to children's personal information receive equivalent training.

10. CONFIDENTIALITY AND PRIVACY

10.1 Information about a child collected through the Reservo platform is sensitive personal information.

10.2 Such information is:
  (a) accessible only to the Driver assigned to the trip and Reservo Operations;
  (b) protected in accordance with the Reservo Privacy Policy;
  (c) retained for 7 years from the trip date, or longer where required by law.

11. RESPONDING TO CONCERNS

11.1 Anyone with a concern about child safety on Reservo may contact:
  (a) admin@reservo.au;
  (b) 0435 679 630;
  (c) the NSW Office of the Children's Guardian or NSW Police for matters requiring external authority involvement.

11.2 No retaliation will be taken against any person making a report in good faith.

12. REVIEW

12.1 This policy is reviewed annually and after any child-safety incident.

---
VERSION HISTORY
v1.0 — 17/05/2026 — Initial draft for solicitor review.

---
THIS DOCUMENT IS A DRAFT FOR PRE-LAUNCH REVIEW.`,
};